export const MOUSE = '@/MOUSE';
export const TOUCH = '@/TOUCH';